import { render, staticRenderFns } from "./ColorGame.vue?vue&type=template&id=37fb4d5b&scoped=true&"
import script from "./ColorGame.vue?vue&type=script&lang=js&"
export * from "./ColorGame.vue?vue&type=script&lang=js&"
import style0 from "./ColorGame.vue?vue&type=style&index=0&id=37fb4d5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb4d5b",
  null
  
)

export default component.exports